<div class="container">
    <form [formGroup]="phoneForm">

        <div *ngIf="is2FA" class="create-password-header">
            <h2>Add password recovery</h2>
            <p class="primary-text">
                Enter your mobile number to set up two-factor authentication for your user account. 
                Your mobile number can also be used to reset your password.
            </p>
        </div>

        <div *ngIf="!is2FA" class="create-password-header">
            <h2>Add password recovery</h2>
            <p class="primary-text">Enter your mobile number to set up password recovery for your user account.</p>
        </div>

        <div class="create-password-body">
            <div class="form-control-group">
                <ds-input 
                    class="full-width"
                    formControlName="phone"
                    [mask]="'(000) 000 - 0000'"
                    (inputValueChanged)="onPhoneChanged($event)"
                    (keyUp)="onPhoneChanged($event)"
                    (ngModelChange)="onPhoneChanged($event)"
                    [disabled]="isLoading"
                    [isLoading]="isLoading"
                    label="Mobile number">
                </ds-input>
    
            </div>
        </div>

        <div class="create-password-footer">
            <p class="primary-text">
                By entering your mobile number, you agree to receive mobile messages at the phone number provided. 
                Message frequency varies. Message and data rates may apply. View our 
                <span (click)="goToPrivacy()" class="primary-text-link">
                    <span class="primary-text-link-text">Privacy Policy</span>
                </span> and 
                <span (click)="gotoTermsOfService()" class="primary-text-link">
                    <span class="primary-text-link-text">Terms of Service</span>.
                </span> 
            </p>
        </div>

        <pnl-error-message [showIcon]="false" *ngIf="activeError"  [error]="activeError"></pnl-error-message>

        <div *ngIf="!is2FA" (click)="onSkipThisStepClicked()" class="skip-step-btn">
            <span class="skip-step-btn-text">Skip this step</span>
        </div>
    </form>
</div>